export enum FamilyMemberFields {
  FirstName = 'firstName',
  LastName = 'lastName',
  DateOfBirth = 'dateOfBirth',
  Dependence = 'dependence',
}
